import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Platform } from 'ionic-angular'
import { Storage } from '@ionic/storage'

import { MODO_DESCONECTADO, NUBE_AWS, RUTA_MODO_DESCONECTADO, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES } from '../../config/url.servicio'

@Injectable()
export class CompaniasProvider {
  public companiasId:string = null;
  token:string
  constructor(public http: Http,public platform:Platform,
              public storages:Storage) {
      this.storages.get('token').then((val) => {
        this.token = val
    });
    this.buscar()
  }
  buscar() {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      return this.http.get(`${url_servicio}/procedure?name=companias`);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=companias`)
      .map((data) => data.json())
   }
  }
  buscarCompaniasId(companiasId:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarCompaniasId",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/proceso/buscarCompaniasId?companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }


  guardar(compania: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: compania.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "companias",
          ...compania
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()}
      , error => {
        console.log(error)});
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.post(`${url}/query`, compania, options)
        .map((data) => data.json())
   }
  }

  actualizar(compania: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: compania.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "companias",
          ...compania
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.put(`${url}/query`, compania, options)
   }
  }

  eliminar(compania: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: compania.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "companias",
          ...compania
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&companiasId=${compania.companiasId}&nombreTabla=companias`, options)
   }
  }
  datosStorage(){
    if(  this.platform.is("cordova")  ){
      // dispositivo
      this.storages.set('companiasId', this.companiasId );
      return this.companiasId
    }else{
      // escritorio
      if( this.companiasId ){
        localStorage.setItem("companiasId", this.companiasId);
        return this.companiasId
      }else{
        localStorage.removeItem("companiasId");
        console.log("companiasId borrada");
        return this.companiasId
      }
    }
  }
  cargarcompaniaId(id:any){
    this.companiasId=id
    this.datosStorage()
  }
buscarId(){
  let promesa = new Promise((resolve,reject)=>{

    if(  this.platform.is("cordova")  ){
      // dispositivo
      this.storages.get('companiasId').then((val)=>{
        resolve(val)
      })

    }else{
      let id = localStorage.getItem("companiasId");
        if(id){
          resolve(id)
        }
      else{
        localStorage.removeItem("companiasId");
        console.log("companiasId borrada");
        this.companiasId = null
        reject(false)
      }
    }


  })
  return promesa
}

devolverVarios(keys: string[]) {
  const promises = [];

  keys.forEach( key => promises.push(this.storages.get(key)) );

  return Promise.all(promises).then( values => {
    const result = {};

    values.map( (value, index) => {
      result[keys[index]] =value;
    });

    return result;
  });
}

guardarInformacionMododesconectado(companiasId: any, values: string){
  if(MODO_DESCONECTADO) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectado",
      parameters : {companiaId:companiasId, "cuantos": values}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
let url = URL_SERVICIOS_LOCALES
let headers = new Headers({
  'Content-Type': 'application/json'
})
let options = new RequestOptions({
  headers: headers
})
let datos: any = {
    "companiaId": companiasId,
    "queHago":"G",
    "name":"guardarInformacionMododesconectado"
  }
return this.http.put(`${url}/query`,datos, options)
  }
}

guardarInformacionMododesconectadoSinRecorrido(companiasId: any){
  if(MODO_DESCONECTADO) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoSinRecorrido",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
let url = URL_SERVICIOS_LOCALES
let headers = new Headers({
  'Content-Type': 'application/json'
})
let options = new RequestOptions({
  headers: headers
})
let datos: any = {
    "companiaId": companiasId,
    "queHago":"G",
    "name":"guardarInformacionMododesconectado"
  }
return this.http.put(`${url}/query`,datos, options)
  }
}

buscarCodigoBarra(companiasId:any,codigo:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarCodigoBarra",
      parameters : {codigo:codigo,
                    companiasId: companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
  let url = URL_SERVICIOS_LOCALES

    return this.http.get(`${url}/proceso/buscarCodigoBarra?companiasId=${companiasId}&codigo=${codigo}`)
    .map((data) => data.json())
 }
}

buscarCodigoUsuarioValido(codigo:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarCodigoUsuarioValido",
      parameters : {codigo:codigo}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
    let url = URL_SERVICIOS_LOCALES

    return this.http.get(`${url}/query?name=buscarCodigoUsuarioValido&codigo=${codigo}`)
    .map((data) => data.json())
  }
}

guardarInformacionMododesconectadoGrupos(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadolistaGruposProductos",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}


guardarInformacionMododesconectadoClientes(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoClientes",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarInformacionMododesconectadoUsuarios(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoUsuarios",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarInformacionMododesconectadoCajaProductos(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoCajaProductos",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}


guardarInformacionMododesconectadoProductos(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoProductos",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarInformacionMododesconectadoGruposProductos(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoGruposProductos",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarInformacionMododesconectadoProdutosPorGrupos(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoProdutosPorGrupos",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}


guardarInformacionMododesconectadoProductosLista(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoListaProductos",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}


guardarInformacionMododesconectadoClienteGenerico(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoclienteGenerico",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarInformacionMododesconectadoDenominaciones(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoDenominaciones",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarInformacionMododesconectadoImprimirReciboCajaModoDesconectado(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoImprimirReciboCajaModoDesconectado",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}


guardarInformacionMododesconectadoRutaModoDesconectado(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoRutaModoDesconectado",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarInformacionMododesconectadoformasDePagoModoDesconectado(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoformasDePago",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  }


guardarInformacionMododesconectadobuscarparametrosGeneralesModoDesconectado(companiasId: any, usuariosId:any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadobuscarparametrosGenerales",
      parameters : {companiaId:companiasId,usuariosId:usuariosId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);

}
guardarInformacionMododesconectadoCompania(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoCompania",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarInformacionMododesconectadoProductosCompanias(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoProductosCompanias",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarInformacionMododesconectadoVentasDiarias(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoVentasDiarias",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

buscarNombreTablas(){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarNombreTablas",
      parameters : {}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

buscarLogPorTabla(companiasId:any,nombre:any){
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "buscarLogPorTabla",
    parameters : {companiasId:companiasId,nombre:nombre}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}

async devolverVariosAsync(keys: string[]) {
  const promises = keys.map(key => this.storages.get(key));
  const values = await Promise.all(promises);

  const result: {[key: string]: any} = {};

  values.forEach((value, index) => {
    result[keys[index]] = value;
  });

  return result;
}

guardarInformacionMododesconectadoMesas(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "guardarInformacionMododesconectadoMesas",
      parameters : {companiaId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}
guardarInformacionMododesconectadoBuscarTurnosAppComandasVacio(companiasId: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "BuscarTurnosAppComandasVacio",
      parameters : {companiasId:companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

gestionarInteresesCreditos(credito: any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: credito.name,
      parameters : {
        name : "dataDynamicCrud",
        nombreTabla: credito.name,
        ...credito
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  gestionarInteresesCreditosArrastrarValor(companiasId: any,valor:any){
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "gestionarInteresesCreditosArrastrarValor",
      parameters : {companiasId:companiasId,valor:valor}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

  async guardarInformacionMododesconectadoVentasDiariasExpress(datos: any){
   try {
    const ipAddress = localStorage.getItem('ipAddress');
    const protocolohttps = localStorage.getItem('protocolohttps');
    const puerto = localStorage.getItem('puerto');
    const url = `${protocolohttps}://${ipAddress}:${puerto}`
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-ventas-diarias`, {data:datos},{ headers: headers }).toPromise();
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async guardarInformacionMododesconectadolistaProductosExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-listaProductos`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoClienteGenericoExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-cliente-generico`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoDenominacionesExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-denominaciones`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoReciboCajaExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-recibocaja`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoGruposExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-grupos`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoClienteExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-clientes`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}



async guardarInformacionMododesconectadoProductosExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-productos`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoGruposProductosExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-grupos-productos`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoProductosPorGruposExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-productos-por-grupos`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoUsuariosExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-usuario`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoCajaProductosExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-caja-productos`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoProductosCompaniasExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-productos-companias`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoCompaniasExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-compania`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoFormasDePagoExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-formas-de-pago`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoParametrosGeneralesExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-parametros-generales`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoMesasExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-mesas`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarInformacionMododesconectadoComandasVaciasExpress(datos: any){
  try {
   const ipAddress = localStorage.getItem('ipAddress');
   const protocolohttps = localStorage.getItem('protocolohttps');
   const puerto = localStorage.getItem('puerto');
   const url = `${protocolohttps}://${ipAddress}:${puerto}`
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option
   const response = await this.http.post(`${url}/guardar-informacion-mododesconectado-comandas-vacias`, {data:datos},{ headers: headers }).toPromise();
   return response;
 } catch (error) {
   console.error('Error fetching data:', error);
   throw error;
 }
}

async guardarComandasModoDesconectado (values: any, numeromesa:any){
  try {
    const ipAddress = localStorage.getItem('ipAddress');
    const protocolohttps = localStorage.getItem('protocolohttps');
    const puerto = localStorage.getItem('puerto');
    const url = `${protocolohttps}://${ipAddress}:${puerto}`
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    const response = await this.http.post(`${url}/guardarComandasModoDesconectado`, {values,numeromesa},{ headers: headers }).toPromise();
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async buscarComandasModoDesconectado (){
  try {
    const ipAddress = localStorage.getItem('ipAddress');
    const protocolohttps = localStorage.getItem('protocolohttps');
    const puerto = localStorage.getItem('puerto');
    const url = `${protocolohttps}://${ipAddress}:${puerto}`
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    const response = await this.http.post(`${url}/buscarComandasModoDesconectado`, {},{ headers: headers }).toPromise();
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async eliminarComandasModoDesconectado (numero:any){
  try {
    const ipAddress = localStorage.getItem('ipAddress');
    const protocolohttps = localStorage.getItem('protocolohttps');
    const puerto = localStorage.getItem('puerto');
    const url = `${protocolohttps}://${ipAddress}:${puerto}`
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    const response = await this.http.post(`${url}/eliminarComandasModoDesconectado`, {numero},{ headers: headers }).toPromise();
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async guardarVentaDesconect(laVenta:any, datosAdicionales:any, imprimir: boolean = false){
  try {
    const ipAddress = localStorage.getItem('ipAddress');
    const protocolohttps = localStorage.getItem('protocolohttps');
    const puerto = localStorage.getItem('puerto');
    const url = `${protocolohttps}://${ipAddress}:${puerto}`
    const datos = {
      "laVenta": JSON.stringify(laVenta),
      "datosAdicionales": JSON.stringify(datosAdicionales),
      "RUTA_MODO_DESCONECTADO":RUTA_MODO_DESCONECTADO,
      "imprimir": imprimir
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    const response = await this.http.post(`${url}/guardar-venta-mododesconectado`, {datos},{ headers: headers }).toPromise();
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async buscarcompaniaInformacionMododesconectado(){
  try {
    const ipAddress = localStorage.getItem('ipAddress');
    const protocolohttps = localStorage.getItem('protocolohttps');
    const puerto = localStorage.getItem('puerto');
    const url = `${protocolohttps}://${ipAddress}:${puerto}`
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    const response = await this.http.post(`${url}/buscarcompaniaInformacionMododesconectado`, {},{ headers: headers }).toPromise();
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async buscarVentasDiariasSinCierreModoDesconectado(){
  try {
    const ipAddress = localStorage.getItem('ipAddress');
    const protocolohttps = localStorage.getItem('protocolohttps');
    const puerto = localStorage.getItem('puerto');
    const url = `${protocolohttps}://${ipAddress}:${puerto}`
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    const response = await this.http.post(`${url}/buscarVentasDiariasSinCierreModoDesconectado`, {},{ headers: headers }).toPromise();
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async buscarVentasDiariasModoDesconectadoPorTurno(turno:any){
  try {
    const ipAddress = localStorage.getItem('ipAddress');
    const protocolohttps = localStorage.getItem('protocolohttps');
    const puerto = localStorage.getItem('puerto');
    const url = `${protocolohttps}://${ipAddress}:${puerto}`
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    const response = await this.http.post(`${url}/buscarVentasDiariasModoDesconectadoPorTurno`, {turno},{ headers: headers }).toPromise();
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}


buscarInteresesCreditosPorCostosAdicionales(companiasId: any, interesesCreditosId:any){
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "buscarInteresesCreditosPorCostosAdicionales",
    parameters : {companiasId:companiasId,interesesCreditosId:interesesCreditosId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);
}

guardarGestionInteresCreditosPorCostosAdicionales(compania: any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: compania.name,
      parameters : {
        name : "dataDynamicCrud",
        nombreTabla: "interesesCreditosPorCostosAdicionales",
        ...compania
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);

}

async validarGestionInteresCreditosPorCostosAdicionales(companiasId: any, interesesCreditosId:any) {
  try {
       let url_servicio = URL_SERVICIOS_AWS;
       let values = {
         name: "validarGestionInteresCreditosPorCostosAdicionales",
         parameters : { companiasId,interesesCreditosId}
       }
       let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
       let options = new RequestOptions({ headers: headers }) // Create a request option
       let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
       return response
 } catch (error) {
   console.error('Error al guardar la placa:', error);
   throw error;
 }
}

eliminarGestionInteresCreditosPorCostosAdicionales(values: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: values.name,
    parameters : {
      name : "dataDynamicCrud",
      nombreTabla: "interesesCreditosPorCostosAdicionales",
      ...values
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);

}

interesesCreditosPorCostosAdicionalesArrastrarValor(companiasId: any,costosAdicionalesId:any,tipo:any,eliminar:string = 'N') {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "interesesCreditosPorCostosAdicionalesArrastrarValor",
    parameters : {companiasId:companiasId,
      costosAdicionalesId:costosAdicionalesId,
      tipo:tipo,
      eliminar:eliminar
    }
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options);

}

async buscarCupo(clientesId:any,companiasId: any){
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "buscarCupo",
      parameters : { clientesId,companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response
} catch (error) {
console.error('Error al guardar la placa:', error);
throw error;
}
}


async buscarProductosPorNombreTendero(companiasId:any,buscarTexto: any){
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "buscarProductosPorNombreTendero",
      parameters : { companiasId,buscarTexto}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response
  } catch (error) {
    console.error('Error al guardar la placa:', error);
    throw error;
  }
}

async buscarCodigoBarraAsync(companiasId:any,codigo:any) {
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarCodigoBarra",
      parameters : {codigo:codigo,
                    companiasId: companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}


buscarProductosPorEmpresaPaginadoInfinito(companiasId:any,pagina:any,cantidadPaginar:any,search:any=null){
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarClientesPorEmpresaPaginadoInfinito",
      parameters : {companiasId:companiasId,pagina:pagina,cantidadPaginar:cantidadPaginar,search:search}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
    .map((data) => data.json())
 }
}

async buscarPermisosPorRutaYCompania(nombre:any,companiasId:any) {
  try {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarPermisosPorRutaYCompania",
      parameters : {nombre:nombre,
                    companiasId: companiasId}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    let response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}


}



// WEBPACK FOOTER //
// ./src/providers/companias/companias.ts